const TIPOS_GRUPO = [
  {
    id: 1,
    name: 'Gestor NEOs',
    // icon: 'group',
    // color: null,
    create: false,
  },
  {
    id: 2,
    name: 'Gestión',
    // icon: 'group',
    // color: null,
    create: true,
  },
  {
    id: 3,
    name: 'Reparto',
    // icon: 'group',
    // color: null,
    create: true,
  },
  // {
  //   id: 4,
  //   name: 'Administradores',
  //   icon: 'group',
  //   color: null,
  //   create: false,
  // },
]

export {
  TIPOS_GRUPO
}
